<form [submitMethod]="submitMethod()" class="flex flex-col gap-4" rxapForm>

  <div class="flex flex-row gap-12 items-center">

    @if (!showOnlyTimeslots()) {
      @if (!hideActiveToggle()) {
        <mat-slide-toggle formControlName="isActive" labelPosition="after">
          <ng-container i18n>Active</ng-container>
        </mat-slide-toggle>
      }

      <mat-form-field>
        <mat-label i18n>Delay in minutes</mat-label>
        <button mat-icon-button matSuffix rxapInputClearButton tabindex="-1" type="button">
          <mat-icon>clear</mat-icon>
        </button>
        <input
          formControlName="delay"
          matInput
          min="0"
          max="9999"
          type="number"
        />
      </mat-form-field>

      <mat-form-field>
        <mat-label i18n>Delay Notification Cascade in minutes</mat-label>
        <button mat-icon-button matSuffix rxapInputClearButton tabindex="-1" type="button">
          <mat-icon>clear</mat-icon>
        </button>
        <input
          formControlName="delayCascade"
          matInput
          min="0"
          max="9999"
          type="number"
        />
      </mat-form-field>
    }

    @if (defaultConfiguration()?.uuid) {
      <button mat-stroked-button type="button" (click)="importDefaultConfiguration()">
        <mat-icon>event_upcoming</mat-icon>
        <ng-container i18n>Import default configuration</ng-container>
      </button>
    }

  </div>

  @if (initialized || initial() === null) {
    <fieldset class="border-4 rounded p-2" formGroupName="timeslots">
      <legend i18n>Timeslots</legend>

      @for (dayOfTheWeek of daysOfTheWeek; let index = $index; track index) {
        <fieldset class="border-4 rounded px-4 pb-2">
          <legend class="flex flex-row gap-1 items-center mb-2">
            <span>{{ dayOfTheWeek.localizedName }}</span>
          </legend>
          <eurogard-timeslot-control [dayIndex]="index"
                                     [enforceCompactDesign]="enforceCompactDesign()"
                                     (copyConfiguration)="copyTimeFrame(index, $event)"
                                     [readOnly]="readOnly()"
                                     [formControlName]="dayOfTheWeek.controlName">
          </eurogard-timeslot-control>
        </fieldset>
      }
    </fieldset>
  }

  @if (!readOnly()) {
    <rxap-form-controls
      [useExternalReset]="true"
      [showCancelButton]="false"
      (resetEvent)="manualReset()"
    ></rxap-form-controls>
  }
</form>
